import axios from "axios";
import { ContentType } from "@/utils/enum";

const SERVER_BASE_URL =
  process.env.SERVER_BASE_URL || process.env.NEXT_PUBLIC_API_BASE_URL;

const serverAxiosInstance = axios.create({
  baseURL: SERVER_BASE_URL,
  headers: {
    "Content-Type": ContentType.JSON,
    "Cache-Control": "no-store, max-age=0, must-revalidate, no-cache",
  },
});

// Request interceptor
serverAxiosInstance.interceptors.request.use(
  (config) => {
    const token = process.env.TOKEN;
    const accessToken = `Bearer ${token}`;

    if (accessToken) {
      if (config.headers) config.headers.Authorization = accessToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// serverAxiosInstance.interceptors.response.use(
//   (response) => {
//     if ([200, 201].includes(response.status)) {
//       return response.data;
//     }
//   },
//   (error) => {
//     if ([401, 403].includes(error?.response?.status)) {
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//     return error;
//   }
// );
//

export default serverAxiosInstance;
